import React from "react";
import PropTypes from "prop-types";

import * as Theme from "../../../../App/Theme";

import HelpIcon from "../../../../Img/DM/Help 32 n p.png";

import GBStdTable from "../../../../Library/Tables/GBStdTableAG/GbStdTable";
import GBStdChart from "../../../../Library/Charts/GBStdChart";
import TRadioGroup from "../../../../Library/RadioGroups/TRadioGroup";
import TComboBox from "../../../../Library/ComboBoxes/TComboBox";
import TLabel from "../../../../Library/Labels/TLabel";
import TDialog from "../../../../Library/Dialogs/TDialog";

import { shouldComponentUpdateGB } from "../../../GB/NonComponents/GBUtil";

import * as DMConst from "../../NonComponents/DMConst";
import { getYearIdx } from "../../NonComponents/DMUtil";

class DMTargVsPriorAchievForm extends React.Component {
    static propTypes = {
        navComboBoxHeight: PropTypes.number,
        results: PropTypes.object,
        selectedSNU_CurrID: PropTypes.number,
    };

    static defaultProps = {
        navComboBoxHeight: 35,
        results: {},
        selectedSNU_CurrID: 1,
    };

    constructor(props) {
        super(props);

        this.state = {
            chartVsTable: DMConst.showChart,
            finalYear: DMConst.defaultFinalDisplayYear,
            showHelpDialog: false,
        };
    }

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onChartTypeRadioGroupChange = (value, info) => {
        try {
            this.setState({
                chartVsTable: value + 1,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onFinalYearComboBoxChange = (value, text, info) => {
        try {
            this.setState({
                finalYear: text,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onHelpBtnClick = () => {
        try {
            this.setState({
                showHelpDialog: !this.state.showHelpDialog,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const results = props.results;
            const res = results[DMConst.rResult1];
            const inputs = results[DMConst.rInputs];
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const navComboBoxHeight = props.navComboBoxHeight;

            const state = this.state;
            const chartVsTable = state.chartVsTable;
            const finalYear = state.finalYear;
            const showHelpDialog = state.showHelpDialog;

            const pointLabels = res[DMConst.rPointLabels];
            const subsetLabels = res[DMConst.rSubsetLabels];
            const data1 = res[DMConst.rData1];
            const SNU_Data = data1[selectedSNU_CurrID];
            const yAxisLabel = res[DMConst.rYAxisLabel];
            const title = res[DMConst.rTitle];

            const t1 = inputs[DMConst.rFirstYearMCIdx];
            const t2 = getYearIdx(finalYear);

            let chart = null;
            let tableTitleLabel = null;
            let noDataDiv = null;
            let table = null;

            if (chartVsTable === DMConst.showChart) {
                const tCurrYear = getYearIdx(DMConst.lastYearProgData + 1);

                /* xAxis point labels */
                let categories = [];
                for (let t = t1; t <= t2; t++) {
                    categories.push(pointLabels[t]);
                }

                /* Series names */
                let series = [{}, {}, {}, {}, {}, {}];
                series[0].name = subsetLabels[DMConst.DP_Infant];
                series[1].name = subsetLabels[DMConst.DP_A10_14];
                series[2].name = subsetLabels[DMConst.DP_A15_19];
                series[3].name = subsetLabels[DMConst.DP_A20_24];
                series[4].name = subsetLabels[DMConst.DP_A25_29];
                series[5].name = subsetLabels[DMConst.DP_A55_59 + 1];

                // Series data
                series[0].data = [];
                series[1].data = [];
                series[2].data = [];
                series[3].data = [];
                series[4].data = [];
                series[5].data = [];
                for (let t = t1; t <= t2; t++) {
                    series[0].data.push(SNU_Data[DMConst.DP_Infant][t]);
                    series[1].data.push(SNU_Data[DMConst.DP_A10_14][t]);
                    series[2].data.push(SNU_Data[DMConst.DP_A15_19][t]);
                    series[3].data.push(SNU_Data[DMConst.DP_A20_24][t]);
                    series[4].data.push(SNU_Data[DMConst.DP_A25_29][t]);
                    series[5].data.push(SNU_Data[DMConst.DP_A55_59 + 1][t]);
                }

                let plotBandLength = -0.5;
                for (let x = t1; x <= tCurrYear; x++) {
                    plotBandLength += 1;
                }

                const chartOptions = {
                    chart: {
                        type: "column",
                        events: {},
                    },

                    title: {
                        text: res.title + " (Current year is populated with estimated target)",
                        x: -20,
                    },

                    xAxis: {
                        categories: categories,
                        labels: {
                            step: 1,
                            rotation: 90,
                        },
                        plotBands: [
                            {
                                from: -0.5,
                                to: plotBandLength, //4.5,
                                color: "rgba(68, 170, 213, .2)",
                            },
                        ],
                    },

                    yAxis: {
                        title: {
                            text: yAxisLabel,
                        },
                        tickAmount: 10,
                        //tickInterval: 5000,
                        plotLines: [
                            {
                                value: 0,
                                width: 1,
                                color: "#808080",
                            },
                        ],
                        reversedStacks: false,
                        labels: {
                            format: "{value:,.0f}",
                        },
                    },

                    plotOptions: {
                        column: {
                            stacking: "normal",
                        },
                        series: {
                            animation: false,
                        },
                    },

                    credits: {
                        text: "",
                    },

                    legend: {
                        layout: "horizontal",
                        align: "center",
                        verticalAlign: "top",
                        borderWidth: 0,
                        y: 20,
                    },

                    roundForDownloadCSV: true,

                    colors: Theme.DM_ChartColors,

                    series: series,
                };

                chart = (
                    <GBStdChart
                        chartType={"column"}
                        id={DMConst.rResult1}
                        key={Date.now()}
                        options={chartOptions}
                        style={{
                            bottom: Theme.configDivStyle.height,
                            left: 0,
                            overflow: "hidden",
                            position: "absolute",
                            right: 0,
                            top: navComboBoxHeight,
                        }}
                    />
                );
            } else {
                if (t2 >= t1) {
                    const numRows = DMConst.DP_A55_59 + 1 - DMConst.DP_Infant + 1 + 1 + 1;
                    const numCols = t2 - t1 + 1 + 1;

                    let tableData2DArray = [];
                    let lockedCells2DBoolArray = [];

                    let a = DMConst.DP_Infant;
                    for (let r = 1; r <= numRows; r++) {
                        tableData2DArray.push([]);
                        lockedCells2DBoolArray.push([]);

                        let t = t1;
                        for (let c = 1; c <= numCols; c++) {
                            /* Column headings (age groups + total) */
                            if (r === 1 && c >= 2) {
                                tableData2DArray[r - 1].push(pointLabels[t]);
                            } else if (c === 1 && r >= 2 && r !== numRows) {
                                /* Row headings (years) */
                                tableData2DArray[r - 1].push(subsetLabels[a]);
                            } else if (c === 1 && r === numRows) {
                                /* Row headings (total row) */
                                tableData2DArray[r - 1].push("Total");
                            } else if (c >= 2 && r >= 2 && r !== numRows) {
                                /* Coverage values */
                                tableData2DArray[r - 1].push(SNU_Data[a][t]);
                            } else {
                                tableData2DArray[r - 1].push("");
                            }

                            lockedCells2DBoolArray[r - 1].push(true);

                            /* Ignore row headings column. */
                            if (c !== 1) {
                                t++;
                            }
                        }

                        /* Ignore column headings row. */
                        if (r !== 1) {
                            a++;
                        }
                    }

                    /* Set VMMC totals at each year. */

                    for (let c = 1; c <= numCols; c++) {
                        let total = 0;

                        for (let r = 1; r <= numRows; r++) {
                            /* Set the VMMCs total at this year. */
                            if (c >= 2 && r === numRows) {
                                tableData2DArray[r - 1][c - 1] = total;
                            } else if (c >= 2 && r > 1 && r <= numRows - 2) {
                                /* Keep a running total of the VMMCs at this year. */
                                total += parseFloat(tableData2DArray[r - 1][c - 1]);
                            }
                        }
                    }

                    let tableData = {
                        value: tableData2DArray,
                    };

                    let packTable = {
                        BandsOn: true,
                        GBColCount: numCols,
                        GBFixedCols: 1,
                        GBFixedRows: 1,
                        GBRowCount: numRows,
                        id: 1,
                        LockedCells: lockedCells2DBoolArray,
                        tableData: tableData,
                    };

                    table = (
                        <GBStdTable
                            headerBackgroundColor={Theme.HL_PrimaryColor}
                            oddRowBackgroundColor={Theme.HL_BandColor}
                            packTable={packTable}
                            onPackTableChanged={() => {}} // do nothing
                            style={{
                                marginLeft: Theme.indent,
                            }}
                            // width              = {900}
                        />
                    );
                } else {
                    noDataDiv = (
                        <div
                            style={{
                                marginLeft: Theme.indent,
                            }}
                        >
                            No data to display
                        </div>
                    );
                }

                tableTitleLabel = (
                    <TLabel
                        caption={res.title + " (Current year is populated with estimated target)"}
                        style={{
                            fontWeight: "bold",
                            marginBottom: Theme.indent,
                            marginLeft: Theme.indent,
                            marginTop: Theme.indent,
                        }}
                    />
                );
            }

            let chartTypeRadioGroupIdx = 0;

            if (chartVsTable === DMConst.showTable) {
                chartTypeRadioGroupIdx = 1;
            }

            const chartTypeRadioGroup = (
                <TRadioGroup
                    handleChange={this.onChartTypeRadioGroupChange}
                    itemIndex={chartTypeRadioGroupIdx}
                    items={["Chart", "Table"]}
                    row={true}
                    style={{
                        marginLeft: Theme.indent,
                    }}
                />
            );

            const finalYearLabel = (
                <TLabel
                    caption={"End of"}
                    style={{
                        marginLeft: 30,
                    }}
                />
            );

            let year1DIntArray = [];

            for (let t = DMConst.firstYear; t <= DMConst.lastPossibleTargetYear; t++) {
                year1DIntArray.push(t.toString());
            }

            const finalYearComboBox = (
                <TComboBox
                    onChange={this.onFinalYearComboBoxChange}
                    itemIndex={finalYear - DMConst.firstYear}
                    items={year1DIntArray}
                    outerStyle={{
                        marginLeft: 5,
                        width: Theme.finalYearComboBoxWidth,
                    }}
                    style={Theme.finalYearComboBoxStyle}
                />
            );

            const helpBtn = (
                <div>
                    <img
                        alt="" // to avoid hint
                        onClick={this.onHelpBtnClick}
                        style={Theme.helpBtnImgStyle}
                        src={HelpIcon}
                    />
                </div>
            );

            const helpDialog = (
                <TDialog
                    caption={title + " (Current year is populated with estimated target)"}
                    content={
                        <div>
                            VMMCs in the shaded area are historical (i.e., have already been conducted by the national
                            program); VMMCs outside of the shaded area are future scale-up targets. The number of VMMCs
                            required by age and year to reach and maintain the user-specified coverage level by the
                            target year. The cross-hatched columns represent VMMCs that have already been conducted by
                            the program (historical VMMCs) and the targets for the current year. The purpose of this
                            graph is for the user to see whether the annual number of target VMMCs is similar to what
                            has been done in the past, or would require many more or fewer circumcisions annually than
                            past achievements. It is a quick visual check for the feasibility of a given set of targets
                            for each SNU. Current year is populated with the estimated target.
                        </div>
                    }
                    actions={["mrOK"]}
                    onClose={this.onHelpBtnClick}
                    style={{
                        width: 1000,
                    }}
                    maxWidth={"xl"}
                    visible={showHelpDialog}
                />
            );

            const configLeftDiv = (
                <div style={Theme.configLeftDivStyle}>
                    {chartTypeRadioGroup}
                    {finalYearLabel}
                    {finalYearComboBox}
                </div>
            );

            const configDiv = (
                <div style={Theme.configDivStyle}>
                    {configLeftDiv}
                    {helpBtn}
                </div>
            );

            const resultDiv = (
                <div
                    style={Theme.resultCenterDiv}
                    key={"resultDiv"}
                >
                    {chart}
                    {tableTitleLabel}
                    {noDataDiv}
                    {table}
                    {helpDialog}
                </div>
            );

            return (
                <div key={"DMTargVsPriorAchievFormDiv"}>
                    {resultDiv}
                    {configDiv}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMTargVsPriorAchievFormDiv"}
                    key={"DMTargVsPriorAchievFormDiv"}
                >
                    <h3 key={"DMTargVsPriorAchievFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMTargVsPriorAchievForm;
